import PremiumAccessGate from '@/features/_shared/UpgradeToPremium/PremiumAccessGate';

const PremiumWidgetDenied = () => {
  return (
    <PremiumAccessGate
      blur='5px'
      buttonSx={{ mt: '8px' }}
      height='542px'
      imageTransform='scale(1.05)'
      variant='preview'
    />
  );
};

export default PremiumWidgetDenied;
